// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Thursday`
};

const el_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Πέμπτη`
};

const ru_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Четверг`
};

const he_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `יום חמישי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const thursday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.thursday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("thursday", locale)
	if (locale === "en") return en_thursday(inputs)
	if (locale === "el") return el_thursday(inputs)
	if (locale === "ru") return ru_thursday(inputs)
	if (locale === "he") return he_thursday(inputs)
	return "thursday"
};